namespace('compass.hotel');

compass.hotel.FilterBreadcrumbWidget = compass.defineWidget(function FilterBreadcrumbWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;

	var _currFilter = { };
	this.updateFilter = function(data) {
		_currFilter = data;
		me.drawBreadcrumbs();
	};

	this.setupControls = function() {

	};

	this.render = function() {

	};

	var _ignoredKeys = {
		'price' : true,
		'distance' : true,
		'rooms' : true,
		'arrive' : true,
		'depart' : true,
		'availability' : true
	};

	this.drawBreadcrumbs = function() {
		var d = _d;
		var widgetElem = me.getWidgetElem().empty();
		for(var key in _currFilter) {
			var filterPair = _currFilter[key];
			if(_ignoredKeys[filterPair.key] !== true && filterPair.value) {
				(function(breadcrumb, filterKey, pair) {
					var filterValue = (pair.key == 'query') ? pair.value : pair.key;
					if(pair.type == 'stars') {
						filterValue += ' Stars';
					}
					breadcrumb.append(
						d.a({ className : 'closeBreadcrumb', href : '#' },
								d.i({ className : 'fa-duotone fa-circle-xmark' }), '&nbsp;' + filterValue).activate(function() {
								breadcrumb.remove();
								widgetElem.trigger('FilterBreadcrumbWidget.closeBreadcrumb', filterKey);
								return false;
							})
					);
					widgetElem.append(breadcrumb);
				})(d.div({ className : 'filterBreadcrumb' }), key, filterPair);
			}
		}
		widgetElem.append(d.separator());
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultFilterBreadcrumbWidgetWUID',
	widgetName : 'FilterBreadcrumbWidget'
});

